module.exports = [{"id":1,"text":"My name is Serhii Ivanchenko and I specialize in Web development."},{"id":2,"text":"I am very interested in professional development and continuous learning. I am greatly motivated by my desire to deliver great results in everything I do. I am open to the people I work with and the relationships I build."},{"id":3,"text":"I am proud of my past but I’m truly excited about my future."}]


//////////////////
// WEBPACK FOOTER
// ./src/data/about.json
// module id = 252
// module chunks = 0